var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative flex flex-col select-none"},[_c('div',{staticClass:"flex mobile:flex-initial items-center self-center space-x-3"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }